import React, { useEffect } from 'react';
import { LazyTemplateGalleryContent } from './LazyTemplateGalleryContent';
const Auth = require('app/scripts/db/auth');

interface TemplatesInAppGalleryProps {
  category?: string;
  shortLink?: string;
}

export const TemplatesInAppGallery: React.FunctionComponent<TemplatesInAppGalleryProps> = ({
  category,
  shortLink,
}) => {
  useEffect(() => {
    !Auth.me().isDismissed('templates-in-app-gallery') &&
      Auth.me().dismiss('templates-in-app-gallery');
  }, []);

  return (
    <div>
      <LazyTemplateGalleryContent
        category={category}
        shortLink={shortLink}
        isInAppGallery
      />
    </div>
  );
};
